import type { PaywallStatus } from "@/react/types";
import { Button } from "@circle-react-uikit/Button";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useModalFooter } from "./hooks/useModalFooter";

interface ModalFooterProps {
  activeTab: string;
  currentPaywallStatus?: PaywallStatus;
  isSubmitting: boolean;
  mutation: {
    isLoading: boolean;
  };
  shouldBlockSubmitButton: boolean;
}

export const ModalFooter = ({
  isSubmitting,
  mutation,
  activeTab,
  shouldBlockSubmitButton,
  currentPaywallStatus,
}: ModalFooterProps) => {
  const {
    isEditingMode,
    currentPrimaryButtonState,
    currentSecondaryButtonState,
    options,
    isCreatingAndLastStep,
    formState,
  } = useModalFooter({ activeTab, currentPaywallStatus });

  return (
    <div className="flex w-full justify-end gap-x-2">
      {isCreatingAndLastStep && (
        <Button
          type="submit"
          variant={currentSecondaryButtonState.variant}
          disabled={
            isSubmitting || mutation.isLoading || shouldBlockSubmitButton
          }
          onClick={currentSecondaryButtonState.onClick}
        >
          {currentSecondaryButtonState.buttonLabel}
        </Button>
      )}
      {isEditingMode && <Dropdown options={options} />}
      <Button
        type="submit"
        variant={currentPrimaryButtonState.variant}
        disabled={
          !formState?.isDirty ||
          isSubmitting ||
          mutation.isLoading ||
          shouldBlockSubmitButton
        }
        onClick={currentPrimaryButtonState.onClick}
      >
        {currentPrimaryButtonState.buttonLabel}
      </Button>
    </div>
  );
};
